define('lib/Podio.UI.Modal',['require','translate','underscore','jquery','lib/Podio.Event.UI','lib/Podio.UI','lib/Podio.Event','lib/Podio.Utils','lib/Podio.FormValidation','signals','lib/LayersEventManager'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var eventUI = require('lib/Podio.Event.UI');
  var podioUI = require('lib/Podio.UI');
  var podioEvent = require('lib/Podio.Event');
  var utils = require('lib/Podio.Utils');
  var formValidation = require('lib/Podio.FormValidation');
  var signalsLib = require('signals');
  var LayersEventManager = require('lib/LayersEventManager');
  var self;

  var elmModal, modalOptions, modalConfirmCallback, modalConfirmCancelCallback, modalState, modalType;

  var signals = {
    onModalClosed: new signalsLib.Signal(),
    onModalCompleted: new signalsLib.Signal(),
    afterModalClosed: new signalsLib.Signal(),
    onModalHidden: new signalsLib.Signal() /* also triggers on outsideclick */
  };

  var defaultOptions = {
    disableCloseOptions: false,
    hideOnOutsideClick: true,
    hideOnEsc: true,
    autoHeight : true,
    width: 720,
    keepScrollPosition: true,
    useFlatTheme: true,
    overlay: true
  };

  //  Helpers
  function cleanupEvents() {
    elmModal.find('> .content').off('outsideclick.modal');
  }

  function hideModal() {
    elmModal = $('.modal');

    if (!elmModal) {
      return;
    }

    if (!elmModal.length) {
      return;
    }

    if (modalOptions && modalOptions.hideHandler && !modalOptions.hideHandler()) {
      return;
    }

    cleanupEvents();

    elmModal.remove();
    removeModalOverlay();

    // Clean up
    elmModal = null;
    modalOptions = null;



    signals.onModalHidden.dispatch();
    LayersEventManager.unregister(self);
  }

  function removeModalOverlay() {
    $('.modal-overlay').remove();
  }

  function getModalMarkup(content, modalOptions) {

    var dialogClass = '';

    if (modalOptions && modalOptions.modalType=='Delete'){
      dialogClass = "modal-delete";
    }else if (modalOptions && modalOptions.modalType=='showConfirm'){
      dialogClass = "modal-confirm";
    }

    var html = '<div class="modal"><div class="content"><div class="modal-wrapper '+ dialogClass +'"><div class="modal-header">';

    if (modalOptions && modalOptions.headerHtml) {
      html += modalOptions.headerHtml;
    }

    if (!modalOptions || (modalOptions && !modalOptions.disableCloseOptions)) {
      html += '<div class="close-button" title="' + t('Close #modal.tooltip') + '" data-modal-action="abort"></div>';
    }

    if (modalOptions && modalOptions.modalType=='Delete'){
      html += "<img src='/images/icons/visual_refresh/alert_icon_red.svg'>";
    }else if (modalOptions && modalOptions.modalType=='showConfirm') {
      html += "<img src='/images/icons/visual_refresh/alert_icon_warning.svg'>";
    }

    if (modalOptions && modalOptions.title) {
      html += '<h2>' + _.escape(modalOptions.title) + '</h2>';
    }

    html += '</div>';

    if (modalOptions && modalOptions.breadcrumb) {
      html += '<div class="modal-breadcrumb">' + modalOptions.breadcrumb + '<div class="clear"></div></div>';
    }

    html += '<div class="modal-content';
    if (modalOptions && modalOptions.breadcrumb) {
      html += ' beneath-breadcrumb';
    }
    html += '">' + content + '</div></div></div></div>';

    return html;
  }

  // Event handlers

  function onModalContentOutsideClicked(e) {
    var elmTarget = $(e.target);

    if (elmTarget.parents('.custom-modal, .simple-balloon').length) {
      // Return early if clicking inside custom modals, as they can appear on top of modals, to avoid the modal underneath is hiding
      return false;
    }

    if (modalOptions && modalOptions.disableCloseOptions) {
      return false;
    }

    hideModal();
  }

  function onKeyDown(e) {

    if (modalOptions && modalOptions.hideOnEsc && e.keyCode === podioUI.KeyCodes.Esc) {
      hideModal();
      e.stopPropagation();
    }

    return true;
  }

  function onConfirmCancelClicked(elmTarget, e) {
    e.stopPropagation();

    hideModal();

    if(_.isFunction(modalConfirmCancelCallback)) {
      modalConfirmCancelCallback();
    }

    clearCallbacks();
  }

  function onConfirmOkClicked(elmTarget, e) {
    e.stopPropagation();

    hideModal();

    if(_.isFunction(modalConfirmCallback)) {
      modalConfirmCallback();
    }

    clearCallbacks();
  }

  function onCloseButtonClick(elmTarget, e) {
    e.stopPropagation();

    triggerModalAction(elmTarget.data('modal-action'));
    hideModal();
    signals.afterModalClosed.dispatch();
  }

  function addOverlay(elmTarget, customClasses) {
    var classNames = 'overlay modal-overlay'.split(' ');

    if (customClasses) {
      classNames.push(customClasses.split(' '));
    }

    var elmExistingOverlay = $('.modal-overlay');

    if(elmExistingOverlay.length) {

      classNames.push('state-visible');
      elmExistingOverlay.attr('class', classNames.join(' '));

    } else {
      var elmModalOverlay = $('<div>', { 'class': classNames.join(' ') });
      elmModalOverlay.appendTo('body');

      // Force reflow
      var of = elmModalOverlay.get(0).offsetWidth;

      elmModalOverlay.addClass('state-visible');
    }

  }

  function showModal(content, options) {
    LayersEventManager.register(self, 'keydown', self.onKeyDown.bind(self));
    modalOptions = $.extend({}, defaultOptions);
    if (options) {
      modalOptions = $.extend(modalOptions, options);
    }

    // Remove existing modal
    var elmExistingModal = $('.modal');
    if (elmExistingModal && elmExistingModal.length) {
      cleanupEvents();
      elmExistingModal.remove();
      elmExistingModal = null;
    }


    // Extract content object is an jQuery element
    if(content instanceof $) {
      content = content.html();
    }

    elmModal = $(getModalMarkup(content, modalOptions));

    // Create new modal

    var elmContent = elmModal.find('> .content').css({
      width: modalOptions.width + 'px',
      marginLeft: '-' + parseInt(modalOptions.width / 2, 10) + 'px',
      visibility: 'visible'
    });

    // Handle options

    if (modalOptions) {

      if(modalOptions.positionTop) {
        elmContent.css('top', modalOptions.positionTop + 'px');
      }

      if (modalOptions.positionBottom) {
        elmContent.css({
          top: 'auto',
          bottom: modalOptions.positionBottom
        });
      }

      if (modalOptions.positionLeft) {
        elmContent.css({
          left: modalOptions.positionLeft,
          marginLeft: 0
        });
      }

      if (modalOptions.positionRight) {
        elmContent.css({
          right: modalOptions.positionRight,
          left: 'auto',
          marginLeft: 0
        });
      }

      if (!modalOptions.autoHeight && modalOptions.height) {
        elmContent.css('height', modalOptions.height + 'px');
      }

      if (modalOptions.useFlatTheme) {
        elmContent.addClass('flat');
      }

      if (modalOptions.className) {
        elmContent.addClass(options.className);
      }

      if (modalOptions.modalClass) {
        elmModal.addClass(modalOptions.modalClass);
      }

      if (!modalOptions.footerHtml) {
        elmModal.addClass('nofooter');
      }

      if (modalOptions.footerHtml) {
        elmModal.removeClass('nofooter');
        elmModal.find('.modal-wrapper').append('<div class="modal-footer">' + modalOptions.footerHtml + '</div>');
      }

      if (modalOptions.contentClass) {
        elmModal.find('.modal-content').addClass(modalOptions.contentClass);
      }

      if (modalOptions.footerClass && modalOptions.footerHtml) {
        elmModal.find('.modal-footer').addClass(modalOptions.footerClass);
      }

      // If the content overlay is open, we shouldn't be influenced by the
      // scroll position at all since there is no-scroll on the body element
      if ($('body').hasClass('no-scroll')) {
        if (modalOptions.keepScrollPosition) {
          elmContent.css('top', $(document).scrollTop() + 82);
        }
      } else {
        if (modalOptions.keepScrollPosition) {
          elmContent.css('top', $(document).scrollTop() + 82);
        } else if (!modalOptions.doNotScrollToTop) {
          $(document).scrollTop(0);
        }
      }

      if (modalOptions.fixed) {
        elmContent.css('position', 'fixed');
      }

    }

    // Inject new modal to DOM
    if (modalOptions.elmContainer) {
      if (modalOptions.overlay) {
        addOverlay('body', modalOptions.customOverlayClass);
      }
      elmModal.appendTo(modalOptions.elmContainer);
    } else {
      if (modalOptions.overlay) {
        addOverlay(elmModal);
      }
      elmModal.appendTo('body');
    }

    // Bind events
    if (modalOptions && modalOptions.hideOnOutsideClick) {
      // make sure clicks that led to opening the modal have been cleared
      // so outsideclick is not registered on them
      _.defer(function() {
        elmModal.find('> .content').on('outsideclick.modal', onModalContentOutsideClicked);
      });
    }

    // Limit tabbing
    podioUI.limitTabbingToElement(elmModal);

    // Callbacks
    if(_.isFunction(modalOptions.showHandler)) {
      modalOptions.showHandler();
    }

    return elmModal;
  }

  function showConfirm(title, body, height, confirm_options, callback, cancelCallback) {
    if (!height) {
      height = 140;
    }

    var options = {
      disableCloseOptions: true,
      hideOnEsc: false,
      hideOnOutsideClick: false,
      title: title,
      height: height,
      width: 560,
      modalType: 'showConfirm'
    };

    if (confirm_options) {
      options = $.extend(options, confirm_options);
    }

    modalConfirmCallback = callback;
    modalConfirmCancelCallback = cancelCallback;

    var yes = confirm_options.yes ? confirm_options.yes : t('Yes');
    var no = confirm_options.no ? confirm_options.no : t('No');

    if (confirm_options.html)
      var markup = body + "<div class=\"modal-confirm-buttons\"> <button class=\"button-new primary confirm-button\">" + _.escape(yes) + "</button> <a class=\"button-new secondary\" href=\"\">" + _.escape(no) + "</a> </div>";
    else
      var markup = _.escape(body) + "<div class=\"modal-confirm-buttons\"> <button class=\"button-new primary confirm-button\">" + _.escape(yes) + "</button> <a class=\"button-new secondary\" href=\"\">" + _.escape(no) + "</a> </div>";

    showModal(markup, options);
  }

  function showDeleteConfirm(modalTitle, title, settings, callback) {
    var options = {
      disableCloseOptions: true,
      title: modalTitle,
      height: 140,
      width: 560,
      modalType: 'Delete'
    };

    var variant = settings.variant ? settings.variant : 'delete';

    if( settings.width ){
      options.width = settings.width;
    }

    modalConfirmCallback = callback;

    var yes, no, typeText, typeValue;

    switch(variant) {
      case 'delete':
        yes = t('Delete');
        no = t('Cancel');
        typeValue = t('delete #modal');
        typeText = t('To delete please type "{0}" #modal').format(typeValue);
        break;
      case 'deleteSpace':
        yes = t('Delete this workspace #pads');
        no = t('Cancel');
        typeValue = t('delete this workspace #modal');
        typeText = t('To delete space please type "{0}" #pads').format(typeValue);
        break;
      case 'deleteApp':
        yes = t('Delete this app #pads');
        no = t('Cancel');
        typeValue = t('delete this app #modal');
        typeText = t('To delete this app please type "{0}" #pads').format(typeValue);
        break;
      case 'deleteItems':
        yes = t('Delete these items #batch_delete');
        no = t('Cancel');
        typeValue = t('delete these items #batch_delete');
        typeText = t('To delete your items please type "{0}" #batch_delete').format(typeValue);
        break;
      case 'deleteUserAccount':
        yes = t('Delete my entire Podio account #pads');
        no = t('Cancel');
        typeValue = t('delete my account #pads');
        typeText = t('To delete your Podio account please type "{0}". #pads').format(typeValue.italics());
        break;
      case 'remove':
        yes = t('Remove');
        no = t('Cancel');
        typeValue = t('remove #modal');
        typeText = t('To remove please type "{0}" #modal').format(typeValue);
        break;
      case 'leave':
        yes = t('Leave #modal');
        no = t('Cancel');
        typeValue = t('leave #modal');
        typeText = t('To leave, please type "{0}" #modal').format(typeValue);
        break;
      case 'cleanup':
        yes = t('Clean up fields #modal');
        no = t('Cancel');
        typeValue = t('cleanup #modal');
        typeText = t('To clean up fields, please type "{0}" #modal').format(typeValue);
        break;
      case 'cancelTrialOrg':
        yes = t('Cancel trial membership #modal');
        no = t('Cancel');
        typeValue = t('cancel #modal');
        typeText = t('To cancel trial membership, please type "{0}" #modal').format(typeValue);

        break;
    }

    var markup = [
      (title ? ("<h4 class='modal-delete-confirm-title'>" + _.escape(title) + "</h4>") : ""),
      (settings.body ? '<div class="modal-delete-confirm-body">' + settings.body + '</div>' : ''), // settings.body MUST BE ESCAPED BY THE CUNSUMER. We are sending in html here :((( refs https://podio.com/podio/development/apps/bugs/items/17116
      "<form class=\"modal-delete-confirm-form\"><div class=\"modal-delete-confirm-input\">",
      "<p>" + typeText + ":</p>",
      "<input type=\"text\" data-validation=\"" + typeValue + "\" class=\"equalToData required\">",
      "</div><div class=\"modal-delete-confirm-buttons\">",
      "<button type=\"submit\" class=\"button-new primary confirm-button\">" + _.escape(yes) + "</button> ",
      "<a class=\"button-new secondary\" href=\"\">" + _.escape(no) + "</a> </div></form></div>"
    ].join('');

    showModal(markup, options);
    _.defer(function(){
      $('.modal .modal-delete-confirm-input input').focus();
    });

    formValidation.init(elmModal.find('form'), {
      submitHandler : function(form) {
        hideModal();

        if(_.isFunction(modalConfirmCallback)) {
          modalConfirmCallback();
        }

        clearCallbacks();
      }
    });
  }

  function showPasswordConfirm(title, body, options, callback, cancelCallback) {
    var modalOptions = _.defaults(options, {
      disableCloseOptions: true,
      title: title,
      height: 140,
      width: 560
    });

    modalConfirmCallback = callback;
    modalConfirmCancelCallback = cancelCallback;

    var yes = t('Ok');
    var no = t('Cancel');

    var markup = body + "<form class=\"modal-password-confirm-form\"><div class=\"modal-password-confirm-input\">"+t('To continue enter your current password #modal')+": <input type=\"password\" class=\"required\"></div><div class=\"modal-password-confirm-buttons\"> <button type=\"submit\" class=\"button-new primary confirm-button\">" + _.escape(yes) + "</button> <a class=\"button-new secondary\" href=\"\">" + _.escape(no) + "</a> </div></form>";

    showModal(markup, modalOptions);

    $('.modal-password-confirm-form input[type=password]').focus();

    formValidation.init(elmModal.find('form'), {
      submitHandler : function(form) {

        if(!modalOptions.disableHideOnSubmit) {
          hideModal();
        }

        if(_.isFunction(modalConfirmCallback)) {
          modalConfirmCallback($(form).find('input[type=password]').val());
        }

        clearCallbacks();
      }
    });
  }

  function showAlert(title, body, height, alert_options, callback) {
    if (!height) {
      height = 140;
    }

    var options = {
      disableCloseOptions: true,
      title: title,
      height: height,
      width: 560
    };

    if (alert_options) {
      options = $.extend(options, alert_options);
    }

    modalConfirmCallback = callback;

    var ok = alert_options && alert_options.ok ? alert_options.ok : t('OK');

    var markup = body + "<div class=\"modal-alert-buttons\"> <button class=\"button-new primary alert-button close-button\" data-modal-action=\"complete\">" + _.escape(ok) + "</button> </div>";

    showModal(markup, options);
  }


  function showLoading(title, options) {
    var loadingOptions = {
      disableCloseOptions: true,
      title: title,
      cancelable: false,
      useFlatTheme: true
    };

    options = $.extend(loadingOptions, options || {});

    var markup = '<div class="loading-modal"> <div class="truenorth_spinner"></div> </div>';

    if(options.cancelable) {
      var elmModalWrapper = $('.modal .content .modal-wrapper');
      if (elmModalWrapper && elmModalWrapper.length) {
        var content = elmModalWrapper.find('.modal-content:not([data-is-loading])');
        markup = '<div class="modal-content" data-is-loading="true">' + markup + '</div>';
        content.hide();
        elmModalWrapper.append(markup);
        setTitle(title);
      } else {
        showModal(markup, options);
      }
    } else {
      showModal(markup, options);
    }
  }

  function cancelLoading(title) {
    var elmModalWrapper = $('.modal .content .modal-wrapper');
    if (elmModalWrapper && elmModalWrapper.length) {
      var elmLoading = elmModalWrapper.find('.modal-content[data-is-loading]');
      var elmContent = elmModalWrapper.find('.modal-content:not([data-is-loading])');
      elmLoading.remove();
      removeModalOverlay();
      elmContent.show();
      setTitle(title);
    }
  }

  function setTitle(title) {
    var elmTitle = $('.modal .content .modal-header h2');
    if(elmTitle.length) {
      elmTitle.html(_.escape(title));
    }
  }

  function isShowingModal() {
    return ($('.modal').length > 0);
  }

  function getModalState() {
    if(_.isUndefined(modalState) || _.isNull(modalState)) {
      modalState = {};
    }
    return modalState;
  }

  function clearModalState() {
    modalState = {};
  }

  function clearCallbacks() {
    modalConfirmCallback = null;
    modalConfirmCancelCallback = null;
  }

  function triggerModalAction(action) {
    switch(action) {
      case 'abort':
        signals.onModalClosed.dispatch();
        podioEvent.trigger('modalAborted');
        break;
      case 'complete':
        signals.onModalCompleted.dispatch();
        podioEvent.trigger('modalCompleted');
        break;
    }
  }

  function availableHeight() {
    var maxHeight = $(window).height();

    // Substract header/footer height
    maxHeight = maxHeight - $('.modal-header').outerHeight() - $('.modal-footer').outerHeight();

    // Substract top offset of modal
    maxHeight = maxHeight - ($('.modal .content').position().top - $(window).scrollTop());

    // And the padding of the content wrapper
    maxHeight = maxHeight - 40;

    // ...and leave some space at the bottom
    maxHeight = maxHeight - 20;

    return maxHeight;
  }

  eventUI.bind('click', 'body > .modal .modal-header .close-button', onCloseButtonClick);
  eventUI.bind('click', 'body > .modal .modal-footer .close-button', onCloseButtonClick);
  eventUI.bind('click', 'body > .modal .modal-content .buttons .close-button', onCloseButtonClick);
  eventUI.bind('click', 'body > .modal .modal-confirm-buttons > a', onConfirmCancelClicked);
  eventUI.bind('click', 'body > .modal .modal-confirm-buttons > button', onConfirmOkClicked);
  eventUI.bind('click', 'body > .modal .modal-alert-buttons > button', onConfirmOkClicked);
  eventUI.bind('click', 'body > .modal .modal-delete-confirm-buttons > a', onConfirmCancelClicked);
  eventUI.bind('click', 'body > .modal .modal-password-confirm-buttons > a', onConfirmCancelClicked);

  podioEvent.bind(podioEvent.Types.modalCompleted, clearModalState);
  podioEvent.bind(podioEvent.Types.modalAborted, clearModalState);

  self = {
    show: showModal,
    hide: hideModal,
    showConfirm: showConfirm,
    showDeleteConfirm: showDeleteConfirm,
    showPasswordConfirm: showPasswordConfirm,
    showLoading: showLoading,
    showAlert: showAlert,
    isShowingModal: isShowingModal,
    state: getModalState,
    cancelLoading: cancelLoading,
    setTitle: setTitle,
    signals: signals,
    availableHeight: availableHeight,
    onKeyDown: onKeyDown
  };
  return self;

});

